import { useEffect } from 'react';
import { RequestStatus, isRequestFulfilled } from '../interface';
import { selectCurrentTrialsState, selectIsProfessionalOrEnterpriseTrial } from '../selectors';
import { getCurrentTrialsThunk } from '../thunks/get-current-trials.thunk';
import { getPortalId } from '../utils/getPortalId';
import { useAppDispatch, useAppSelector } from './index';
export const useIsProfessionalOrEnterpriseTrial = () => {
  const portalId = getPortalId();
  const dispatch = useAppDispatch();
  const {
    status
  } = useAppSelector(selectCurrentTrialsState);
  const isProOrEntTrial = useAppSelector(selectIsProfessionalOrEnterpriseTrial);
  useEffect(() => {
    if (status !== RequestStatus.IDLE) {
      return;
    }
    void dispatch(getCurrentTrialsThunk(portalId));
  }, [dispatch, portalId, status]);
  return {
    isProOrEntTrial,
    isProOrEntTrialLoaded: isRequestFulfilled(status)
  };
};
export default useIsProfessionalOrEnterpriseTrial;